export const getDistance = (point1, point2) => {
    const dx = point1.x - point2.x;
    const dy = point1.y - point2.y;

    return Math.sqrt(dx * dx + dy * dy);
}

export const isPointNearPath = (point, path, threshold = 5) => {
    if (!path || path.length < 2) return false;

    for (let i = 0; i < path.length - 1; i++) {
        const p1 = path[i];
        const p2 = path[i + 1];
        const distance = distanceToLineSegment(point, p1, p2);
        if (distance <= threshold) return true;
    }
    return false;
}

export const distanceToLineSegment = (point, lineStart, lineEnd) => {
    const A = point.x - lineStart.x;
    const B = point.y - lineStart.y;
    const C = lineEnd.x - lineStart.x;
    const D = lineEnd.y - lineStart.y;
  
    const dot = A * C + B * D;
    const lenSq = C * C + D * D;
    let param = -1;
  
    if (lenSq !== 0) {
      param = dot / lenSq;
    }
  
    let xx, yy;
  
    if (param < 0) {
      xx = lineStart.x;
      yy = lineStart.y;
    } else if (param > 1) {
      xx = lineEnd.x;
      yy = lineEnd.y;
    } else {
      xx = lineStart.x + param * C;
      yy = lineStart.y + param * D;
    }
  
    const dx = point.x - xx;
    const dy = point.y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  };


export const generateCirclePath = (startPoint, endPoint) => {
    const centerX = startPoint.x;
    const centerY = startPoint.y;
    const radius = getDistance(startPoint, endPoint);

    const points = [];
    const segments = 64;

    for (let i = 0; i < segments; i++) {
        const angle = (i / segments) * 2 * Math.PI;
        points.push({
            x: parseFloat((centerX + radius * Math.cos(angle)).toFixed(1)),
            y: parseFloat((centerY + radius * Math.sin(angle)).toFixed(1))
        });
    }
    return points;
}

export const generateSquarePath = (startPoint, endPoint) => {
    const minX = Math.min(startPoint.x, endPoint.x);
    const maxX = Math.max(startPoint.x, endPoint.x);
    const minY = Math.min(startPoint.y, endPoint.y);
    const maxY = Math.max(startPoint.y, endPoint.y);
  
    return [
      { x: minX, y: minY },
      { x: maxX, y: minY },
      { x: maxX, y: maxY },
      { x: minX, y: maxY },
      { x: minX, y: minY },
    ];
  };


export const pointsToPathString = (points) => {
    if (!points || points.length < 2) return '';
  
    let path = `M ${points[0].x} ${points[0].y}`;
    for (let i = 1; i < points.length; i++) {
      path += ` L ${points[i].x} ${points[i].y}`;
    }
  
    if (points.length > 2) {
      const first = points[0];
      const last = points[points.length - 1];
      const distance = getDistance(first, last);
      if (distance < 1) {
        path += ' Z';
      }
    }
  
    return path;
  };

  
  export const findPathAtPoint = (point, allPaths, orientation, threshold = 5) => {
    const currentOrientationPaths = allPaths.filter(
      (pathObj) => pathObj.orientation === orientation
    );
  
    for (let i = 0; i < currentOrientationPaths.length; i++) {
      const pathObj = currentOrientationPaths[i];
      if (isPointNearPath(point, pathObj.path, threshold)) {
        return allPaths.indexOf(pathObj);
      }
    }
  
    return -1;
  };